module.exports = __webpack_public_path__ + "img/8c70e43.png";